import Api from '@/services/api.js'

export default {
  getBillingPeriods() {
    return Api.get(`billingPeriods/`)
  },
  createBillingPeriod(payload) {
    return Api.post('billingPeriods', payload)
  },
  updateBillingPeriod(id, payload) {
    return Api.put(`billingPeriods/${id}`, payload)
  }
}
